import { Injectable } from '@angular/core';
import { Helpers } from '../helpers';

export class SelectOptions {
    constructor(obj: SelectOptions = {} as SelectOptions) {
        this.controlId == 'select2';
        this.placeholder = '--Please Select--';
        Object.assign(this, obj);
    }
    controlId?: string;
    url?: string;
    displayProperty?: any;
    data?: any[];
    placeholder?: string;
    closeOnSelect?: boolean;
    templateResult?: any;
    multiple?: boolean;
    allowClear?: boolean;
    selectedOptions?: any[];
    selectedOption?: SelectedOption;
}

export class SelectedOption {
    constructor(id: string, text: string) {
        this.id = id;
        this.text = text;
        this.selected = true;
    }
    id: string;
    text: string;
    private selected: boolean;
}

export enum SelectEvent {
    change = 'change.select2',
    closing = 'select2:closing',
    close = 'select2:close',
    opening = 'select2:opening',
    open = 'select2:open',
    selecting = 'select2:selecting',
    select = 'select2:select',
    unselecting = 'select2:unselecting',
    unselect = 'select2:unselect'
}

export class Options {
    url: string;
    method: string;
    data: Object;
    constructor(url: string, method?: string, data?: Object) {
        this.url = url;
        this.method = method || "get";
        this.data = data || {};
    }
}

@Injectable()
export class SelectService {
    public init(options: SelectOptions) {
        options = new SelectOptions(options);
        const controlId = options.controlId;
        let select2Options = this.getDefaultSelect2Options(options);
        if (options.url != null) {
            var apiEndpoint = Helpers.getApiEndpoint();
            var token = Helpers.getAccessToken();
            select2Options['ajax'] = {
                url: apiEndpoint + options.url,
                headers: {
                    Authorization: 'Bearer ' + token
                },
                dataType: 'json',
                delay: 250,
                data: function(params) {
                    return {
                        query: params.term || ''
                    };
                },
                processResults: function(data, params) {
                    params.page = params.page || 1;
                    return {
                        results: data.data,
                        pagination: {
                            more: false //(params.page * 30) < data.count
                        }
                    };
                },
                cache: true
            };
        }

        if (options.data != null) {
            select2Options['data'] = options.data;
        }
        if (options.multiple != null) {
            select2Options['multiple'] = options.multiple;
        }
        if (options.placeholder != null) {
            select2Options['placeholder'] = options.placeholder;
        }
        if (options.closeOnSelect != null) {
            select2Options['closeOnSelect'] = options.closeOnSelect;
        }
        if (options.templateResult != null) {
            select2Options['templateResult'] = options.templateResult;
        }
        if (options.allowClear != null) {
            select2Options['allowClear'] = options.allowClear;
        }
        var select = (<any>$('#' + controlId)).select2(select2Options);
        if (options.selectedOption != null) {
            this.setSelectedValue(options.controlId, options.selectedOption);
        } else if (options.selectedOptions != null) {
            this.setSelectedValues(options.controlId, options.selectedOptions);
            select.trigger({
                type: 'select2:select',
                params: {
                    data: options.selectedOptions
                }
            });
        }

        return select;
    }


    public getSelectedValues(controlId: string) {
        return (<any>$('#' + controlId)).select2('data');
    }

    public setSelectedValues(
        controlId: string,
        selectedOptions: SelectedOption[]
    ) {
        for (let i = 0; i < selectedOptions.length; i++) {
            const option = selectedOptions[i];
            var $newOption = new Option(option.text, option.id, true, true);
            (<any>$('#' + controlId)).append($newOption).trigger('change');
        }
    }

    public setSelectedValue(controlId: string, selectedOption: SelectedOption) {
        var $newOption = (<any>$('<option></option>'))
            .val(selectedOption.id)
            .text(selectedOption.text);
        return (<any>$('#' + controlId)).append($newOption).trigger('change');
    }

    private getDefaultSelect2Options(options) {
        var self = this;
        return {
            escapeMarkup: function(markup) {
                return markup;
            },
            templateResult: function(repo) {
                if (repo.loading) {
                    return repo.text;
                }
                var value = self.getDisplayProperty(repo, options.displayProperty);
                var markup =
                    "<div class='select2-result-repository clearfix'>" +
                    "<div class='select2-result-repository__meta'>" +
                    "<div class='select2-result-repository__title'>" +
                    value +
                    '</div></div></div>';
                return markup;
            },
            templateSelection: function(repo) {
                if (repo.id == '') return repo.text;
                if (repo.selected == true) return repo.text;
                return self.getDisplayProperty(repo, options.displayProperty);
            }
        };
    }

    private getDisplayProperty(entity: any, displayProperty: any) {
        if (typeof displayProperty == 'function') {
            return displayProperty(entity);
        } else if (typeof displayProperty == 'string')
            return entity[displayProperty] || entity.text;
        else return entity.toString();
    }
}



// WEBPACK FOOTER //
// /Users/creative/Documents/GitHub/makrooreservation/src/ui/src/app/_services/select.service.ts